import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import HomeServices from './pages/HomeServices';
import HomeTechnologies from './pages/HomeTechnologies';
import HomeContact from './pages/HomeContact';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import { Toaster } from './components/ui/toaster';
import { useGoogleAnalytics } from './hooks/useGoogleAnalytics';
import CookieConsent from './components/CookieConsent';

function AppContent() {
  // Initialize Google Analytics tracking (respects cookie consent)
  useGoogleAnalytics();

  return (
    <>
      <Routes>
        <Route path="/" element={
          <>
            <Home />
            <HomeServices />
            <HomeTechnologies />
            <HomeContact />
          </>
        } />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
      </Routes>
      <Toaster />
      <CookieConsent />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </div>
  );
}

export default App;